import React from "react";
import "./HomeBanner.css";
import {Link} from "react-router-dom";

export default function HomeBanner(props) {

    return (
        <>
            <div
                className="relative mt-2"
            >
                <div
                    className="relative w-full overflow-hidden after:clear-both after:block after:content-['']">
                    <div
                        className=" home-banner-image-container relative float-left -mr-[100%] w-full transition-transform duration-[600ms] ease-in-out motion-reduce:transition-none"
                    >
                        <img
                            src="/images/sm.webp"
                            className={"block sm:hidden w-full"}
                            alt="lg-sm"/>
                        <img
                            src="/images/md.webp"
                            className={"hidden sm:block md:hidden w-full"}
                            alt="lg-md"/>
                        <img
                            src="/images/lg.webp"
                            className={"hidden md:block lg:hidden w-full"}
                            alt="lg-lg"/>
                        <img
                            src="/images/xl.webp"
                            className={"hidden lg:block xl:hidden w-full"}
                            alt="lg-xl"/>
                        <img
                            src="/images/xxl.webp"
                            className={"hidden xl:block w-full"}
                            alt="lg-xxl"/>
                        <div
                            className="absolute inset-x-[11%] top-10 sm:top-20 md:top-12 lg:top-15 2xl:top-20 text-start text-[#163578]">
                            <p className={"text-[2rem] sm:text-[2.7rem] font-bold w-[50%] md:w-[53%] lg:w-[40%] xl:w-[35%] 2xl:w-[28%] leading-10"}>{props.title}</p>
                            <p className={"text-[1.3rem] font-medium hidden md:block my-8 2xl:my-10 md:w-[67%] lg:w-[67%] xl:w-[53%] 2xl:w-[45%] leading-7"}>{props.text}</p>
                            <div className={"mt-2 sm:mt-6 md:mt-0"}><Link to="/finance#report"
                                className={"rounded-md bg-[#163578] text-white md:text-lg px-5 py-2 font-bold w-fit tracking-wide"}>{props.btnTxt}</Link></div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    );
}
